/**
 * Client-side stage-action vocabulary. These mirror the retired GraphQL enums
 * of the legacy `GetStageActions`/`StageActionModel` API (removed from the
 * schema when the candidate flows moved to `myRole.stages.actions`): the FE
 * still uses them as its own display/type constants for action cards, test
 * intros, and the accessibility-adjustments flow.
 */

export enum StageCandidateActionType {
  AiInterviews = 'AI_INTERVIEWS',
  CodingExternalAssessment = 'CODING_EXTERNAL_ASSESSMENT',
  CognitiveInductiveTest = 'COGNITIVE_INDUCTIVE_TEST',
  CognitiveNumericalTest = 'COGNITIVE_NUMERICAL_TEST',
  CognitiveVerablTest = 'COGNITIVE_VERABL_TEST',
  DeiForm = 'DEI_FORM',
  EnglishProficiencyTest = 'ENGLISH_PROFICIENCY_TEST',
  Form = 'FORM',
  PersonalityTest = 'PERSONALITY_TEST',
  RssAssessment = 'RSS_ASSESSMENT',
  TalentReviewTest = 'TALENT_REVIEW_TEST',
}

/** Display availability of a stage action card. */
export enum StageActionAvailabilityStatus {
  Available = 'AVAILABLE',
  Completed = 'COMPLETED',
  NotAvailable = 'NOT_AVAILABLE',
}
